// extracted by mini-css-extract-plugin
export default {"container":"Policy_container__vEqsq","heading":"Policy_heading__aS34k","list":"Policy_list__HsJ4J","itemStress":"Policy_itemStress__bKqHO"};